<div class="shared-modal position-relative">
    <h4 class="d-flex justify-content-between align-items-center crossbtn">Book your free consultation
        <img (click)="onNoClick()" class="align-top"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'" alt="Close | Luminous" />
    </h4>
    <div class="text-center">
        <div class="mt-5 consult-form">
            <app-inputforms *ngIf="showForm" [formName]="formName" (formSubmit)="submitForm($event)">
            </app-inputforms>
        </div>
    </div>
</div>
